import styled from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

export const StyledLoader = styled.div`
   ${basicSmallTextStyle};
`;

StyledLoader.displayName = 'StyledLoader';
